/**
 * An accepted noticing offer is asked as the notch asked it: one converse turn
 * from the moment's own surface (the host is the shell's, stamped by the
 * client). Its actions ride the belt, so a task it starts joins the shell's
 * feed and a navigation goes to the main window; its words land on the
 * crown as the reply (the notch showed it), opening the task when the turn
 * started or followed one.
 */
import { converseStream } from "@/lib/composer/converse-client";
import { performRouterAction } from "@/components/composer/routerActions";
import { useDockShellStore } from "./dockShell";
import { TROUBLE_ALONE } from "./lineWorkModel";

const NO_ROUTER = { push: () => {} };

export async function askFromMoment(
  prompt: string,
  title: string
): Promise<void> {
  let text = "";
  let taskId: string | undefined;
  let failed = false;
  for await (const ev of converseStream(
    { input: prompt, surface: "moment_card" },
    { stream: true }
  )) {
    if (ev.type === "text_delta") text += ev.text;
    else if (ev.type === "error") failed = true;
    else if (ev.type === "action") {
      if (
        ev.action.kind === "task_created" ||
        ev.action.kind === "task_followup"
      )
        taskId = ev.action.taskId;
      performRouterAction(ev.action, NO_ROUTER);
    }
  }
  const words = text.trim() || (failed && !taskId ? TROUBLE_ALONE : "");
  if (words)
    useDockShellStore.setState({
      reply: { title, text: words, ...(taskId ? { taskId } : {}) },
    });
}
